import { post } from './request';
export var sendFrog = function (url, data) {
    return post(url, data);
};
